// extracted by mini-css-extract-plugin
export var backdropBlur = "_e9-0";
export var contentCard = "_e9-5";
export var frame = "_e9-2";
export var image = "_e9-4";
export var imagePane = "_e9-3";
export var modal = "_e9-1";